export default __webpack_public_path__ + "727ab50acc54d0e28b1626a3631a8664.png";